import baseService from './baseService';

export const getContacts = (page, per_page, search, filters, sorting) =>
  baseService.get(`/member/user_contacts`, {
    params: {
      page,
      per_page,
      search,
      filters,
      sorting,
    },
  });

export const getTags = () => baseService.get(`/member/contact_tags`);

export const createTag = (selectedContacts, tag) =>
  baseService.post(`/member/contact_tags/link_new_tags`, { contact_tag: { selectedContacts, tag } });

export const updateTag = (selectedContacts, tagsToAdd, tagsToDelete) =>
  baseService.put(`/member/contact_tags/link_existing_tags`, {
    contact_tag: { selectedContacts, tagsToAdd, tagsToDelete },
  });

export const getSyncData = () => baseService.get(`/member/source_integrations`);

export const getSources = () => baseService.get(`/member/sources`);

export const createContact = (data) =>
  baseService.post(`/member/user_contacts`, {
    contact: data,
  });

export const getContactDetails = (id) => baseService.get(`/member/user_contacts/${id}`);

export const destroyContact = (id) => baseService.delete(`/member/user_contacts/${id}`);

export const updateContact = (data) =>
  baseService.patch(`/member/user_contacts/${data.id}`, {
    contact: data,
  });

export const bulkDeleteContacts = (ids) => baseService.delete(`/bulk/member/user_contacts`, { params: { ids } });

export const mergeContacts = (ids) => baseService.put(`/member/user_contacts/merge_contacts`, { ids });

export const toggleConnectSync = (id, changeTo) =>
  baseService.patch(`/member/source_integrations/${id}`, { source_integration: { is_synced: changeTo } });

export const deleteSync = (id) => baseService.delete(`/member/source_integrations/${id}`);

export const uploadCSV = (file) => {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } };
  const data = new FormData();
  data.append('csvData', file);
  return baseService.post(`/member/user_contacts/upload_user_contacts_csv`, data, config);
};

export const uploadVCF = (file) => {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } };
  const data = new FormData();
  data.append('vcfData', file);
  return baseService.post(`/member/user_contacts/bulk_create_user_contact_vcf`, data, config);
};

export const uploadMapping = (file, mapping) => {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } };
  const data = new FormData();
  data.append('csvData', file);
  mapping.forEach((e) => {
    data.append('mapping[]', JSON.stringify(e));
  });
  return baseService.post(`/member/user_contacts/update_csv_headings`, data, config);
};

export const importContacts = (file, mapping, time) => {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } };
  const data = new FormData();
  data.append('csvData', file);
  data.append('time', time);
  mapping.forEach((e) => {
    data.append('mapping[]', JSON.stringify(e));
  });
  return baseService.post(`/member/user_contacts/bulk_create_user_contact`, data, config);
};

export const fetchImportHistory = (source) => baseService.get(`/member/user_contact_import_histories?source=${source}`);
export const fetchImportHistoryCount = () => baseService.get(`/member/user_contact_import_histories/histories_count`);
export const removeImportHistory = (id) => baseService.delete(`/member/user_contact_import_histories/${id}`);
